/**
 * Reveal WhatsApp FAB after scroll threshold — keeps PDP sticky ATC unobstructed until user explores.
 */
(function () {
  var root = document.querySelector('[data-whatsapp-chat]');
  if (!root) return;

  var threshold = parseInt(root.getAttribute('data-reveal-after') || '180', 10);
  if (Number.isNaN(threshold) || threshold < 0) threshold = 180;

  function update() {
    if (window.scrollY >= threshold) {
      root.classList.add('whatsapp-chat--revealed');
    } else {
      root.classList.remove('whatsapp-chat--revealed');
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
